module.exports = __webpack_public_path__ + "img/question-mark-icon.eea092ea.svg";